import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {gql, useLazyQuery} from "@apollo/client/index";
import Alert from "@material-ui/lab/Alert/Alert";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from "@material-ui/core/Button/Button";
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import Grid from "@material-ui/core/Grid/Grid";

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: 5,
    },
    progress: {
        marginTop: -4
    },
    contactIcon: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 0,
        marginBottom: 10
    },
    contacts: {
        marginTop: 10,
        marginBottom: 30,
    },
    handle: {
        borderTop: '1px dashed #ccc'
    },
    button: {
        marginLeft: 0
    },
    actions: {
        marginTop: 10
    },
    fullWidth: {
       width: '100%'
    }
}));

const APPROVE_OFFER = gql`
  query($requestCode: String, $updateHash: String) {
    approveOffer(requestCode: $requestCode, updateHash: $updateHash) {
        message
    }
  }
`;

export default function ApproveOfferAction(props) {

    const classes = useStyles();

    let [approveOffer, {loading, data, error}]
        = useLazyQuery(APPROVE_OFFER, {variables: {requestCode: props.request.code, updateHash: props.request.updateHash}});

    const handleClickApprove = () => {
        approveOffer();
    };

    if (!loading && data) {
        data = null;
        props.onActionComplete();
    }

    return (
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    expanded={true}
                >
                    <Typography className={classes.heading}>Approve Offer</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.handle}>
                    <Grid className={classes.fullWidth}>
                        {data ? <Grid item><Alert  className={classes.fullWidth} severity={"success"}>Offer is approved</Alert><p></p></Grid> : ''}

                        {error ? <Grid item><Alert  className={classes.fullWidth} severity={"error"}>{error.message}</Alert><p></p></Grid> : ''}

                        {loading ? <Grid item><LinearProgress className={classes.fullWidth} /></Grid> : ''}
                        <Grid item className={classes.fullWidth}>
                            <div className={classes.actions}>
                                <div className={classes.button}>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        disabled={loading}
                                        endIcon={<ThumbUpIcon>Approve <b>${
                                            new Intl.NumberFormat().format(props.request.anotherOfferAmountMinorUnits / 100)
                                        }</b></ThumbUpIcon>}
                                        onClick={handleClickApprove}
                                    >
                                        Approve&nbsp;<b>${
                                        new Intl.NumberFormat().format(props.request.anotherOfferAmountMinorUnits / 100)
                                    }</b>
                                    </Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}